<template>
  <div>
    <modal-cadu
        close
        :width="560"
        v-model="valueData"
    >
        <div slot="all" class="pt-10 pb-4 px-8">
            <div slot="header">
                <div class="font-secundaria headline font-weight-bold pb-4" style="color: #00995D">
                    EDITAR HIERARQUIA
                </div>
            </div>
            <div slot="body">
              <v-row class="line-down" no-gutters>
                <v-col cols="12" md="7" class="pr-3 pb-2">
                    <validation-provider ref="unimedPai" mode="eager" rules="required" v-slot="{ errors }">
                        <autocomplete-cadu
                            :errorMessage="errors[0]"
                            style="white-space: nowrap"
                            placeholder=""
                            title="Escolha quem está acima da Unimed"
                            v-model="acimaUnimed.nome"
                            :items="listaAcimaUnimed.map((el) => el.textoExibicao)"
                            @index="indexAcima"
                        />
                    </validation-provider>
                </v-col>
                <v-col cols="12" md="5" class="pt-3" align-self="center">
                    <checkbox-cadu @input="loadingRecarregar" :checked="objEdicaoHierarquia.ignorarAvo" :disable="arrUnimeds.length > 1 ? !podeIgnorarAvo : false">
                        <div slot="text"> Desconsiderar 2° hierarquia </div>
                    </checkbox-cadu>
                </v-col>
                <v-col cols="auto" class="pb-2">
                    <a v-if="!segundaFiliacao && listaAcimaUnimedSecundaria.length > 0" @click="adicionarDupla" style="color: #1492E6;">
                        + adicionar dupla filiação
                    </a>
                </v-col>
                <v-row v-if="segundaFiliacao">
                    <v-col cols="12" md="7" class="pr-3 pb-4">
                        <autocomplete-cadu
                            style="white-space: nowrap"
                            placeholder=""
                            title="Segunda filiação"
                            v-model="secundariaUnimed.nome"
                            :items="listaAcimaUnimedSecundaria.map((el) => el.textoExibicao)"
                            @index="indexSecundaria"
                        />
                    </v-col>
                    <v-col align-self="center" col="auto" class="pl-0 pt-8">
                        <button-rounded iconName="x" :iconSize="16" class="remove-dupla-filiacao" @click="removeDupla"/>
                    </v-col>
                </v-row>
              </v-row>
              <v-row class="mt-2">
                  <v-col cols="12">
                      <div class="fontColor--text subtitle-2">
                          Pré-visualização da Hierarquia
                      </div>
                      <v-row v-if="arrUnimedsComputed().length > 0" style="height: 100px">
                        <v-col v-for="(unimed, index) in arrUnimedsComputed()" :key="index" cols="auto" align-self="center">
                          <tooltip-help 
                            width="400"
                            v-if="index < arrUnimedsComputed().length -1 || (index === arrUnimedsComputed().length -1 && unimed.nomeFantasia.length > 20)"
                            :text="getTextTooltip(index, unimed)"
                            :tooltipName="unimed.nomeFantasia"
                          />
                          <div v-else>
                            {{`${unimed.codigo} - ${unimed.nomeFantasia}`}}
                          </div>
                          <span class="ml-4" v-if="((index !== arrUnimedsComputed().length - 2 && unimedSecundaria) || !unimedSecundaria) && index < arrUnimedsComputed().length -1"> >> </span>
                          <span class="ml-4" style="position: relative; top: 12px;" v-if="index === arrUnimedsComputed().length - 2 && unimedSecundaria"> >> </span>
                          <div v-if="unimedSecundaria && index === arrUnimedsComputed().length - 2">
                            <tooltip-help width="400" v-if="index < arrUnimedsComputed().length -1" :text="unimedSecundaria.codigo + ''" :tooltipName="unimedSecundaria.nomeFantasia"/>
                          </div>
                          <div>
                              {{!ignoraAvo || index === 0 ? index + 1 : index + 2}}ª
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else>
                          <v-col cols="auto" class="pb-0">
                            Hierarquia não encontrada
                          </v-col>
                      </v-row>
                  </v-col>
              </v-row>
              <v-row class="mt-2">
                  <v-col cols="12">
                      <textarea-cadu
                        title="Observação"
                        v-model="observacao"
                        :colorText="$vuetify.theme.themes.light.fontColor1"
                        :max="'300'"
                      />
                  </v-col>
              </v-row>
            </div>
            <div slot="footer" class="pt-6">
                <v-row justify="end">
                    <v-col cols="auto">
                        <button-cadu outline @click="valueData = false">
                            FECHAR
                        </button-cadu>
                    </v-col>
                    <v-col cols="auto" @click="salvarHierarquia">
                        <button-cadu>
                            CONFIRMAR
                        </button-cadu>
                    </v-col>
                </v-row>
            </div>
        </div>
    </modal-cadu>
    <overlay-loading :value="isLoadingOverlay" />
    <error-modal
        :value="showError"
        @input="fecharModal"
        :errObj="errObj"
    />
  </div>
</template>

<script>
import ModalMixin from '@/Mixins/ModalMixin'
import Hierarquia from '@/services/Hierarquia'
import { ValidationProvider } from 'vee-validate'

export default {
  components: {
    ValidationProvider
  },
  mixins: [ModalMixin],
  props: {
    idUnimed: {
      type: [String, Number],
      required: false,
      default: ''
    },
    codigoUnimed: {
      type: [String, Number],
      required: false,
      default: ''
    }
  },
  data () {
    return {
      isLoadingOverlay: false,
      error: false,
      showError: false,
      errObj: {},
      acimaUnimed: {
        nome: '',
        id: ''
      },
      secundariaUnimed: {
        nome: '',
        id: ''
      },
      checkSegunda: false,
      listaAcimaUnimed: [],
      tokenBearer: localStorage.getItem('tokenBearer'),
      arrUnimeds: [],
      observacao: '',
      hierarquia: {},
      segundaFiliacao: false,
      objEdicaoHierarquia: {},
      listaAcimaUnimedSecundaria: [],
      abrirModalNovamente: false,
      ignoraAvo: false,
      unimedSecundaria: {},
      podeIgnorarAvo: false
    }
  },
  methods: {
    async loadingRecarregar (value) {
      this.isLoadingOverlay = true
      this.objEdicaoHierarquia.ignorarAvo = !this.objEdicaoHierarquia.ignorarAvo
      await this.recarregaHierarquia()
      this.isLoadingOverlay = false
    },
    async indexSecundaria (index) {
      this.secundariaUnimed.id = index !== null && index > -1 ? this.listaAcimaUnimedSecundaria[index].id : ''
      this.objEdicaoHierarquia.unimedPaiSecundario = index !== null && index > -1 ? {
        id: this.secundariaUnimed.id
      } : null
      this.isLoadingOverlay = true
      await this.recarregaHierarquia()
      this.isLoadingOverlay = false
    },
    fecharModal () {
      this.showError = false
      if (this.error) {
        this.valueData = false
      } else {
        this.$nextTick(() => {
          this.valueData = true
        })
      }
    },
    async start () {
      this.limpaCampos()

      this.hierarquia = new Hierarquia(this.tokenBearer, this.$appConfig.config.API, this.idUnimed)

      this.isLoadingOverlay = true
      await this.iniciaEdicao()
      await this.carregaListaUnimedsAcima()

      if (this.arrUnimeds.length > 1 && this.listaAcimaUnimed.indexOf(this.objEdicaoHierarquia.unimedPai) === -1) {
        this.listaAcimaUnimed.push(this.objEdicaoHierarquia.unimedPai)
      }

      if (!this.objEdicaoHierarquia.unimedPai) {
        await this.recarregaHierarquia()
      }
      this.populateData()
      this.isLoadingOverlay = false
      this.$nextTick(() => {
        this.valueData = !this.error
      })
    },
    limpaCampos () {
      this.secundariaUnimed = {
        nome: '',
        id: ''
      }
      this.arrUnimeds = []
      this.listaAcimaUnimed = []
      this.acimaUnimed = {
        nome: '',
        id: ''
      }
      this.abrirModalNovamente = false
      this.error = false
      this.showError = false
      this.unimedSecundaria = {}
    },
    async carregaListaUnimedsAcima () {
      try {
        const response = await this.hierarquia.paisHierarquia(this.idUnimed)
        this.listaAcimaUnimed = response.data
      } catch (err) {
        this.error = true
        this.setError(err)
      }
    },
    async iniciaEdicao () {
      try {
        let response = await this.hierarquia.getUnimedEdicao(this.idUnimed)
        response = response.data
        response.ignorarAvo = response.ignorarAvo === null ? false : response.ignorarAvo
        this.objEdicaoHierarquia = response
      } catch (err) {
        this.valueData = false
        this.abrirModalNovamente = true
        this.setError(err)
      }
    },
    populateData () {
      this.segundaFiliacao = this.objEdicaoHierarquia.paiSecundario
      if (this.objEdicaoHierarquia.unimedPai) {
        this.acimaUnimed = {
          id: this.objEdicaoHierarquia.unimedPai.id,
          nome: this.objEdicaoHierarquia.unimedPai.textoExibicao
        }
      }
      this.observacao = this.objEdicaoHierarquia.observacao
    },
    adicionarDupla () {
      this.segundaFiliacao = true
    },
    async removeDupla () {
      this.segundaFiliacao = false
      this.secundariaUnimed.nome = {
        nome: '',
        id: ''
      }
      this.objEdicaoHierarquia.unimedPaiSecundario = null
      this.isLoadingOverlay = true
      await this.recarregaHierarquia()
      this.isLoadingOverlay = false
    },
    async salvarHierarquia () {
      let valid = await this.$refs.unimedPai.validate()
      if (valid.valid) {
        this.valueData = false
        await this.$nextTick()
        try {
          this.isLoadingOverlay = true
          this.objEdicaoHierarquia.observacao = this.observacao
          await this.hierarquia.finalizarEdicao(this.objEdicaoHierarquia)
          this.isLoadingOverlay = false
          this.$emit('reload')
        } catch (err) {
          this.setError(err)
        }
      }
    },
    inputAcima (value) {
      this.acimaUnimed.nome = value
    },
    async indexAcima (index) {
      this.acimaUnimed.id = index !== null && index > -1 ? this.listaAcimaUnimed[index].id : ''
      if (index !== null && index > -1) {
        this.objEdicaoHierarquia.unimedPai = {
          id: this.acimaUnimed.id
        }
        this.isLoadingOverlay = true
        await this.recarregaHierarquia()
        this.isLoadingOverlay = false
      }
    },
    async recarregaHierarquia () {
      try {
        let response = await this.hierarquia.infoHierarquia(this.objEdicaoHierarquia)
        response = response.data

        this.podeIgnorarAvo = response.podeIgnorarAvo
        this.listaAcimaUnimedSecundaria = response.unimedsPaisSecundariosPermitidas
        this.arrUnimeds = response.hierarquiaAcimaResultante
        this.ignoraAvo = this.arrUnimeds[1].ignorado || false
        this.objEdicaoHierarquia.ignorarAvo = this.ignoraAvo
        this.unimedSecundaria = this.arrUnimeds[this.arrUnimeds.length - 1].paiSecundario
        this.segundaFiliacao = !!this.unimedSecundaria
        if (this.unimedSecundaria) {
          this.unimedSecundaria.textoExibicao = `${this.unimedSecundaria.codigo} - ${this.unimedSecundaria.nomeFantasia}`
          this.secundariaUnimed = {
            id: this.unimedSecundaria.id,
            nome: this.unimedSecundaria.textoExibicao
          }
        } else {
          this.unimedSecundaria = null
        }
      } catch (err) {
        console.error(err)
        this.setError(err)
      }
    },
    setError (err) {
      if (err.response.status) {
        this.valuedData = false
        this.showError = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        this.isLoadingOverlay = false
      }
    },
    arrUnimedsComputed () {
      return this.arrUnimeds.filter((el) => !el.ignorado)
    },
    getTextTooltip(index, unimed) {
      return index === this.arrUnimedsComputed().length - 1 && unimed.nomeFantasia.length > 20 
      ? `${unimed.codigo} - ${unimed.nomeFantasia.substring(0, 20)}...` 
      : unimed.codigo + ""
    }
  }
}
</script>

<style lang="sass" scoped>
.line-down
    border-bottom: 1px solid #9e9e9e

.remove-dupla-filiacao
    &:hover
        cursor: pointer !important
</style>
